import React, { PropsWithChildren, Suspense } from "react";

import LinearProgress from "@mui/material/LinearProgress";

export const ProgressSuspenseComponent: React.FC<PropsWithChildren> = ({ children }) => (
  <Suspense fallback={<LinearProgress />}>{children}</Suspense>
);
